export default {
      id: "search-18-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#search-18-usage",
      toString: function () {
        return this.url;
      }
    }